import { render, staticRenderFns } from "./changeRemark2.vue?vue&type=template&id=aa949446&scoped=true"
import script from "./changeRemark2.vue?vue&type=script&lang=js"
export * from "./changeRemark2.vue?vue&type=script&lang=js"
import style0 from "./changeRemark2.vue?vue&type=style&index=0&id=aa949446&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa949446",
  null
  
)

export default component.exports